/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1PersonSharedMaritalStatusDropdown200,
  GetApiV1PersonSharedMaritalStatusDropdown401,
  GetApiV1PersonSharedMaritalStatusDropdown500,
  GetApiV1PersonSharedMaritalStatusDropdownQueryResponse,
} from "../../types/personSharedController/GetApiV1PersonSharedMaritalStatusDropdown.ts";
import { dropDownListViewModelSchema } from "../dropDownListViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1PersonSharedMaritalStatusDropdown200Schema = z.array(
  z.lazy(() => dropDownListViewModelSchema),
) as unknown as ToZod<GetApiV1PersonSharedMaritalStatusDropdown200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1PersonSharedMaritalStatusDropdown401Schema =
  z.any() as unknown as ToZod<GetApiV1PersonSharedMaritalStatusDropdown401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1PersonSharedMaritalStatusDropdown500Schema =
  z.any() as unknown as ToZod<GetApiV1PersonSharedMaritalStatusDropdown500>;

export const getApiV1PersonSharedMaritalStatusDropdownQueryResponseSchema =
  z.lazy(
    () => getApiV1PersonSharedMaritalStatusDropdown200Schema,
  ) as unknown as ToZod<GetApiV1PersonSharedMaritalStatusDropdownQueryResponse>;
